import { render, staticRenderFns } from "./AiReportingChat.vue?vue&type=template&id=34451251&scoped=true&"
import script from "./AiReportingChat.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReportingChat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiReportingChat.vue?vue&type=style&index=0&id=34451251&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34451251",
  null
  
)

export default component.exports